import { MealTime } from "@/clients/models/MealTime";

export const mealTabs = [
  MealTime.BREAKFAST,
  MealTime.LUNCH,
  MealTime.DINNER,
  MealTime.SNACK,
];

export const mealTabsLabel = {
  [MealTime.BREAKFAST]: "Breakfast",
  [MealTime.LUNCH]: "Lunch",
  [MealTime.DINNER]: "Dinner",
  [MealTime.SNACK]: "Snacks",
};

const overviewMealTime = {
  all: "all",
  breakfast: MealTime.BREAKFAST,
  lunch: MealTime.LUNCH,
  dinner: MealTime.DINNER,
  snack: MealTime.SNACK,
} as const;

export type OverviewMealTimeKeys = keyof typeof overviewMealTime;

export const overviewMealTabs: OverviewMealTimeKeys[] = Object.keys(
  overviewMealTime,
) as OverviewMealTimeKeys[];

export const overviewMealTabsLabel = {
  [overviewMealTime.all]: "Overview",
  [overviewMealTime.breakfast]: "Breakfast",
  [overviewMealTime.lunch]: "Lunch",
  [overviewMealTime.dinner]: "Dinner",
  [overviewMealTime.snack]: "Snacks",
};
